import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import aboutimg from "./images/Dr-Rajesh-Bhardwaj..ba39b548b45da76b6b4f.png";
import { Link } from "react-router-dom";

export default function AboutDoctor() {
  const [showModal, setShowModal] = useState(false);

  // Prevent background scroll when modal open
  useEffect(() => {
    document.body.style.overflow = showModal ? "hidden" : "auto";
  }, [showModal]);

  // Modal component using React Portal
  const Modal = ({ children, onClose }) => {
    const modalContent = (
      <div
        className="modal-overlay"
        onClick={onClose}
        aria-modal="true"
        role="dialog"
        tabIndex={-1}
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.35)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 99999,
          padding: "1rem",
          overflowY: "auto",
        }}
      >
        <div
          className="modal-content"
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: "#fff",
            borderRadius: "16px",
            width: "100%",
            maxWidth: "400px",
            maxHeight: "90vh",
            overflowY: "auto",
            padding: "1.5rem 2rem",
            boxShadow: "0 15px 40px rgba(40, 167, 69, 0.25)",
            position: "relative",
            animation: "scaleIn 0.3s ease forwards",
            boxSizing: "border-box",
          }}
        >
          {children}
        </div>
      </div>
    );

    return ReactDOM.createPortal(modalContent, document.body);
  };

  return (
    <section className="pq-home2-about" style={{ position: "relative", zIndex: 0 }}>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-7 mt-4 mt-lg-0 contentr-button">
            <div className="pq-section pq-style-1 text-left">
              <span
                className="pq-section-sub-title"
                style={{ color: "#28a745", fontWeight: "600", fontSize: "18px" }}
              >
                Contact Us
              </span>
              <h2
                className="pq-section-title"
                style={{ color: "#28a745", fontSize: "32px", fontWeight: "700", marginTop: "5px" }}
              >
                Get an Appointment with us
              </h2>
              <br />
              <p className="pq-section-description" style={{ color: "#131313bd", fontSize: "16px", lineHeight: "1.6" }}>
                MedFirst ENT Centre was established in 1997. Since then it has undergone regular improvements and
                upgradation to become a centre of excellence for the diagnosis and management of ENT disorders in the
                NCR. We get patients from all over India and overseas as well. We offer the latest technology and
                equipment and expertise in the management of ENT diseases.
              </p>
              <p style={{ fontWeight: "600", fontSize: "16px" }}>
                Dr. (Major) Rajesh Bhardwaj
                <br />
                MBBS (AFMC), MS, DNB, DLO, DHA
              </p>
            </div>

            <a
              className="pq-button pq-button-flat"
              href="https://entdelhi.com/about-doctor-rajesh-bhardwaj/"
              style={{ color: "#28a745", fontWeight: "600", textDecoration: "none" }}
            >
              <div className="pq-button-block" style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}>
                <span className="pq-button-text">Read More</span>{" "}
                <i className="fa-solid fa-arrow-right-long" style={{ color: "#28a745" }}></i>
              </div>
            </a>
          </div>

          <div className="col-lg-5">
            <div className="about-us-img">
              <img
                src={aboutimg}
                className="img-fluid pq-image1 wow fadeInRight"
                alt="Dr. Rajesh Bhardwaj"
                style={{ borderRadius: "12px" }}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="container mt-5">
        <div className="row">
          <div className="col-lg-12 mt-4 mt-lg-0">
            <div className="card shadow-lg border-0 rounded-4 p-4 bg-light">
              <div className="card-body text-center">
                <p className="contact-text" style={{ fontSize: "16px" }}>
                  Please feel free to contact us at{" "}
                  <strong>
                    <a href="tel:+919205585295" style={{ color: "#28a745", textDecoration: "none" }}>
                      +91 9205585295
                    </a>
                  </strong>{" "}
                  for emergency cases.
                </p>
                {/* <button
                  className="btn btn-primary btn-lg mt-3 rounded-pill px-4"
                  onClick={() => setShowModal(true)}
                  style={{
                    backgroundColor: "#28a745",
                    borderColor: "#28a745",
                    fontWeight: "600",
                    boxShadow: "0 4px 15px rgba(40,167,69,.4)",
                    transition: "background-color 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#218838")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#28a745")}
                >
                  Book an Appointment
                </button> */}
                <Link
                to={'/book-an-appointment'}
                  className="btn btn-primary btn-lg mt-3 rounded-pill px-4"
                  style={{
                    backgroundColor: "#28a745",
                    borderColor: "#28a745",
                    fontWeight: "600",
                    boxShadow: "0 4px 15px rgba(40,167,69,.4)",
                    transition: "background-color 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#218838")}
                  onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#28a745")}
                >
                  Book an Appointment
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Popup */}
      {showModal && (
        <Modal onClose={() => setShowModal(false)}>
          <div
            style={{
              marginBottom: "1rem",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <h5 style={{ color: "#28a745", margin: 0, fontWeight: "700" }}>Book an Appointment</h5>
            <button
              type="button"
              onClick={() => setShowModal(false)}
              style={{
                background: "transparent",
                border: "none",
                fontSize: "1.5rem",
                fontWeight: "700",
                color: "#28a745",
                cursor: "pointer",
              }}
              aria-label="Close modal"
            >
              &times;
            </button>
          </div>

          <form>
            <div className="mb-3">
              <label className="form-label" style={{ fontWeight: "600", color: "#333" }}>
                Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter your name"
                required
                style={{
                  borderRadius: "8px",
                  borderColor: "#28a745",
                  padding: "10px",
                  fontSize: "1rem",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              />
            </div>
            <div className="mb-3">
              <label className="form-label" style={{ fontWeight: "600", color: "#333" }}>
                Phone
              </label>
              <input
                type="tel"
                className="form-control"
                placeholder="Enter your phone number"
                required
                style={{
                  borderRadius: "8px",
                  borderColor: "#28a745",
                  padding: "10px",
                  fontSize: "1rem",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              />
            </div>
            <div className="mb-3">
              <label className="form-label" style={{ fontWeight: "600", color: "#333" }}>
                Email
              </label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                required
                style={{
                  borderRadius: "8px",
                  borderColor: "#28a745",
                  padding: "10px",
                  fontSize: "1rem",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              />
            </div>
            <div className="mb-3">
              <label className="form-label" style={{ fontWeight: "600", color: "#333" }}>
                Message
              </label>
              <textarea
                className="form-control"
                rows="3"
                placeholder="Your message or concern"
                required
                style={{
                  borderRadius: "8px",
                  borderColor: "#28a745",
                  padding: "10px",
                  fontSize: "1rem",
                  width: "100%",
                  boxSizing: "border-box",
                }}
              ></textarea>
            </div>
            <button
              type="submit"
              className="btn w-100"
              style={{
                backgroundColor: "#28a745",
                borderColor: "#28a745",
                color: "white",
                fontWeight: "700",
                padding: "12px",
                borderRadius: "50px",
                fontSize: "1.1rem",
                cursor: "pointer",
                transition: "background-color 0.3s ease",
                width: "100%",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#218838")}
              onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#28a745")}
            >
              Submit
            </button>
          </form>
        </Modal>
      )}
    </section>
  );
}
